import { faLoader } from "@fortawesome/pro-regular-svg-icons";
import Card from "components/card/Card";
import DataTable from "components/dataTable/DataTable";
import Sheet from "components/sheet/Sheet";
import Spin from "components/spin/spin";
import useModal from "hooks/modals/useModal";
import { useAppDispatch } from "hooks/redux";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { selectDate } from "redux/actions/teesheet";
import { TFacilityStatus } from "redux/reducers/models/facility";
import EmptyStatus from "../../emptyStatus/EmptyStatus";
import "./courseStatus.scss";

interface IProps {
  statuses: Array<TFacilityStatus>;
  date: Date;
}

export default function CourseStatus(props: IProps) {
  const { statuses, date } = props;
  const { t } = useTranslation();
  const { state: viewAllModal, updateModal: updateViewAllModal, closeModal: closeViewAllModal } = useModal();
  const history = useHistory();
  const dispatch = useAppDispatch();

  return (
    <>
      <Card
        title={t("Course Status")}
        titleActions={[
          {
            content: t("View All"),
            action: () => updateViewAllModal({ isOpen: true }),
            disabled: !statuses || statuses?.length === 0,
          },
        ]}
      >
        <Card.Section>
          {!statuses ? (
            <div style={{ height: "40px", display: "flex", width: "40px", margin: "auto" }}>
              <Spin />
            </div>
          ) : statuses?.length === 0 ? (
            <EmptyStatus
              title="No Statuses Set (Yet)"
              description="Add today's update for everyone to stay informed."
              action={{
                label: "View daily status",
                onClick: () => {
                  dispatch(selectDate(date));
                  history.push("/admin/teesheet", {
                    params: { autoOpenDailyStatus: true },
                  });
                },
              }}
              icon={faLoader}
            />
          ) : (
            <div className="ui-course-status">
              {statuses
                ?.filter((_, index) => index < 4)
                ?.map((facilityStatus, index) => {
                  return (
                    <div key={index} className="ui-course-status-card">
                      <p className="ui-course-status-text-primary">{facilityStatus?.label}</p>
                      <p className="ui-course-status-text-secondary">{facilityStatus?.value}</p>
                    </div>
                  );
                })}
            </div>
          )}
        </Card.Section>
      </Card>
      <Sheet
        open={viewAllModal.isOpen}
        title={t("View All Course Statuses")}
        size="medium"
        onCancel={closeViewAllModal}
        backDropCancel
      >
        <DataTable columns={[{ label: t("Title") }, { label: t("Status") }]}>
          {statuses?.map((facilityStatus, index) => {
            return (
              <tr key={index}>
                <td>{facilityStatus?.label}</td>
                <td>{facilityStatus?.value}</td>
              </tr>
            );
          })}
        </DataTable>
      </Sheet>
    </>
  );
}
